class DiscountCode extends HTMLElement {
  constructor() {
    super();
    this.copyButton = this.querySelector('[data-copy-button]');
    this.discountCode = this.dataset.discountCode;
  }

  connectedCallback() {
    this.copyButton.addEventListener('click', this.copyToClipboardBound);
  }

  disconnectedCallback() {
    this.copyButton.removeEventListener('click', this.copyToClipboardBound);
  }

  async copyToClipboard() {
    try {
      await navigator.clipboard.writeText(this.discountCode);
      this.copyButton.classList.add('copied');

      setTimeout(() => {
        this.copyButton.classList.remove('copied');
      }, 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  }

  copyToClipboardBound = this.copyToClipboard.bind(this);
}

if (!customElements.get('discount-code')) {
  customElements.define('discount-code', DiscountCode);
}